var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "612px",
    height: "612px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.818,
    y: 83.455,
    width: 556.363,
    height: 27.818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,142.68v437.914c0,1.975,1.752,3.588,3.922,3.588h604.183c2.17,0,3.895-1.613,3.895-3.588V142.68 c0-1.976-1.753-3.589-3.895-3.589H3.922C1.752,139.091,0,140.704,0,142.68z M486.818,194.727 c23.033,0,41.728,18.694,41.728,41.728c0,23.033-18.694,41.727-41.728,41.727s-41.728-18.694-41.728-41.727 C445.091,213.421,463.785,194.727,486.818,194.727z M55.581,517.696l167.938-268.195c2.031-3.895,5.508-3.867,7.678-0.111 l90.604,156.45c1.112,1.919,3.533,2.42,5.313,1.168l76.861-54.051c3.589-2.531,8.373-1.642,10.794,2.114l139.675,162.986 c2.364,3.7,0.64,6.704-3.505,6.704H59.726C55.414,524.762,53.55,521.619,55.581,517.696z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.636,
    y: 27.818,
    width: 500.727,
    height: 27.818
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.99b23f6ea9a91774b4c2a16292417eed.svg";
export { ForwardRef as ReactComponent };